import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import {
  plainCard,
  text_xscap,
  heading_s,
  text_s,
  mq,
  svg,
  restrictCardTitle
} from '_utils/styles';
import { spacing } from '_utils/props';

export const Card = styled(NavLink)`
  ${({ theme }) => plainCard({ theme })}
  ${({ theme }) => spacing({ theme, $p: 3 })}
  width: 100%;
  display: flex;

  flex: 1 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  color: inherit;
  text-decoration: none;

  position: relative;

  ${mq('lg')} {
    height: 100%;
  }

  &:after {
    content: '';
    position: absolute;
    width: 98%;
    height: 90%;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    box-shadow: ${({ theme }) => theme.card.boxShadow};
    transition: box-shadow 0.2s linear;
    z-index: -1;
  }

  &:hover {
    &:after {
      box-shadow: ${({ theme }) => theme.card.boxShadowHover};
    }
  }
`;

export const Category = styled.p`
  ${text_xscap}
  margin: 0;
`;

export const AttributesWrapper = styled.span`
  ${text_s}
  margin: 8px 0 0 0;
  display: block;
  color: ${({ theme }) => theme.card.secondary};
  flex: none;
`;

export const LinkIconContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ArrowWrapper = styled.span`
  ${svg(14, 14)}
  width: 14px;
  margin-left: 12px;
  flex: none;
  align-self: flex-start;

  path {
    fill: ${({ theme }) => theme.card.action};
  }
`;

export const Title = styled.span`
  ${heading_s}

  &:not(:first-child) {
    ${({ theme }) => spacing({ theme, $mt: 1 })}
  }

  ${Card}:hover & {
    color: ${({ theme }) => theme.card.action};
  }

  ${restrictCardTitle}
`;

export const TitleIconWrapper = styled.span`
  white-space: nowrap;
  line-height: 0;
`;
